import { guideSteps } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <SectionHeading
          index="05"
          title="到底哪个好？三步挑法"
          desc="与其纠结排名先后，不如照着顺序筛一遍。三步走完，基本能定下适合自己的那个平台。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {guideSteps.map((item) => (
            <div
              key={item.step}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <span className="font-heading text-4xl font-bold text-background-300">
                {item.step}
              </span>
              <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
              <span className="mt-5 inline-flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-check-double-line text-base"></i>
              </span>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-lg bg-primary-500 px-6 py-6 md:flex-row md:px-8">
          <div className="text-center md:text-left">
            <h3 className="font-heading text-lg font-bold text-background-50">
              还没定下来？直接看入口清单
            </h3>
            <p className="mt-1.5 text-sm text-primary-50">
              把推荐与合集里的入口集中排在一处，照着点开逐个试一遍最直观。
            </p>
          </div>
          <a
            href="#collections"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-links-line text-sm"></i>
            </span>
            查看入口清单
          </a>
        </div>
      </div>
    </section>
  );
}